import React from 'react';
import PDFViewer from 'pdf-viewer-reactjs';

const link = 'https://fh.filgolf.com/files/ele/F_Proxy_Form.pdf';

export default function F() {
  return (
    <>
      <h5 className="is-size-5 mb-4">
        <strong>F. Proxy Form</strong>
      </h5>
      <a className="button  is-link" href={link} download>
        DOWNLOAD
      </a>
      <PDFViewer
        document={{
          url: link
        }}
        rotationAngle={0}
        css="customViewer"
      />
    </>
  );
}
